// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"styles_wrapper__27ga_","wrapper_left":"styles_wrapper_left__f_ZcM","wrapper_right":"styles_wrapper_right__o8bfy"};